import css from './Loading.module.css'

const Loading = ()=> (
  <div className={css.main}>
    <span className={css.loader} />
  </div>
)

export default Loading